import * as React from "react";

const ReservationTimer: React.FC = () => {
  const [countSecs, setCountSecs] = React.useState(900);

  React.useEffect(() => {
    const intervalId = setInterval(() => {
      setCountSecs(countSecs => countSecs - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const restMintues = Number.parseInt(`${countSecs / 60}`, 10);
  const restSecs = countSecs % 60;
  return (
    <div>
      Pozostały czas {restMintues}: {restSecs}
    </div>
  );
};

export default ReservationTimer;
